@if (country) {
  <div class="modal-header">
    <h3 class="mb-0">{{ Owner && Owner.id ? 'Edit owner' : 'Add owner' }}</h3>
    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="close()"
    ></button>
  </div>

  <div class="modal-body">
    <form [formGroup]="OwnerFormGroup">
      <app-owner-edit
        [OwnerFormGroup]="OwnerFormGroup"
        [country]="country!"
        [showLexisNexisId]="true"
        [hasOwnerSSNAccess]="hasOwnerSSNAccess"
        [ownerHasSSN]="!!Owner?.hasSSN"
        [revealedOwnerSSN]="revealedOwnerSSN"
        [isEditMode]="!!(Owner && Owner.id)"
        (viewOwnerSSNEvent)="viewOwnerSSN()"
      ></app-owner-edit>
    </form>
  </div>

  <div class="modal-footer">
    <div class="action-row justify-end w-100">
      <button type="button" class="btn btn-ghost" (click)="close()">
        Cancel
      </button>
      <button type="button" class="btn btn-primary" (click)="save()">
        Save
      </button>
    </div>
  </div>
}
